import { cn } from "@/lib/utils";

interface MasterDetailLayoutProps {
  list: React.ReactNode;
  detail: React.ReactNode | null;
  listWidth?: string;
  emptyDetail?: React.ReactNode;
}

export default function MasterDetailLayout({
  list,
  detail,
  listWidth = "lg:w-96",
  emptyDetail,
}: MasterDetailLayoutProps) {
  return (
    <div className="flex h-full">
      {/* List panel — full width on mobile, fixed width on desktop */}
      <div
        className={cn(
          "w-full flex-shrink-0 lg:overflow-y-auto lg:border-r lg:min-w-[320px]",
          listWidth,
        )}
      >
        {list}
      </div>

      {/* Detail panel — hidden on mobile, flex-1 on desktop */}
      <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:overflow-hidden lg:min-w-0">
        {detail ?? emptyDetail ?? (
          <div className="flex flex-1 items-center justify-center text-muted-foreground">
            <p>Select an item to view details</p>
          </div>
        )}
      </div>
    </div>
  );
}
